import "core-js/modules/es.function.name";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import eitsApi from '@/apis/eitsApi';
import LoginPageLayout from '@/views/Layout/LoginPageLayout.vue';

var ResetPassword = /*#__PURE__*/function (_Vue) {
  _inherits(ResetPassword, _Vue);

  var _super = _createSuper(ResetPassword);

  function ResetPassword() {
    _classCallCheck(this, ResetPassword);

    return _super.apply(this, arguments);
  }

  _createClass(ResetPassword, [{
    key: "changeBack",
    value: function changeBack(payload) {
      if (payload.type === 'success') {
        this.$router.push({
          name: 'Login'
        });
      }
    }
  }, {
    key: "beforeRouteEnter",
    value: function beforeRouteEnter(to, from, next) {
      if (to.params.verifyCode || to.params.productCode) {
        next();
      } else {
        this.$store.dispatch('FedLogOut').then(function () {
          next('/pageLogin');
        });
      }
    }
  }, {
    key: "challengeCodeUrl",
    get: function get() {
      return eitsApi.CHALLENGE_CODE_SDK;
    }
  }, {
    key: "changePwdUrl",
    get: function get() {
      return eitsApi.CHANGE_PWD_SDK;
    }
  }, {
    key: "phoneNo",
    get: function get() {
      return this.$route.params.name;
    }
  }, {
    key: "productCode",
    get: function get() {
      return this.$route.params.productCode;
    }
  }, {
    key: "verifyCode",
    get: function get() {
      return this.$route.params.verifyCode;
    }
  }]);

  return ResetPassword;
}(Vue);

ResetPassword = __decorate([Component({
  components: {
    LoginPageLayout: LoginPageLayout
  }
})], ResetPassword);
export default ResetPassword;